'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginControllerBase = function () {
  function LoginControllerBase($location, $state, $stateParams, authService, appConfig, pushService, angularAuth0, enums) {
    (0, _classCallCheck3.default)(this, LoginControllerBase);


    this.$state = $state;
    this.$location = $location;
    this.$stateParams = $stateParams;
    this.authService = authService;
    this.appConfig = appConfig;
    this.pushService = pushService;
    this.angularAuth0 = angularAuth0;
    this.enums = enums;

    this.loginType = '';
    this.status = "";
    this.errorMessage = "";

    this.loginData = {
      email: "",
      password: ""
    };
  }

  (0, _createClass3.default)(LoginControllerBase, [{
    key: 'initialize',
    value: function initialize() {
      console.log('Use Auth0', this.appConfig.useAuth0);

      //OAuth Integrations with External Providers
      if (this.$location.search().code) {
        var state = JSON.parse(this.$location.search().state);

        if (!state.provider) {
          this.$state.go('enquiryEditCode', { enquiryId: state.enquiryId, action: state.action, code: this.$location.search().code });
        } else if (state.provider === 'mazda') {
          this.status = "UserAuthorizing";
          var _state = JSON.parse(this.$location.search().state);

          this.authService.mazdaLoginBackend(this.$location.search().code, _state.stateName, _state.stateParams);
        }

        return;
      }

      if (this.appConfig.useAuth0) {
        if (!this.redirectIfAlreadyLoggedIn2()) {
          if (this.$location.hash()) {
            console.log('$location.hash()', this.$location.hash());
            var hashParams = this.splitHash();

            this.status = "UserAuthorizing";
            if (hashParams.id_token) {
              //Auth0 Client Side Authentication Validaton
              this.handleAuth0Authentication();
            } else {
              //Auth0 Server Side Authentication Validaton
              this.authorize_Auth0(hashParams.access_token);
            }

            return;
          }
        }
      } else {
        if (this.$location.search().code) {
          this.status = "UserAuthorizing";
          this.authorize(this.$location.search().code);
        } else {
          this.redirectIfAlreadyLoggedIn();
        }
      }

      if (this.$stateParams.isAdmin) {
        this.showAdminLogin();
      }
    }
  }, {
    key: 'externalLogin',
    value: function externalLogin() {
      var state = this.$location.search().state || '';
      if (state) {
        window.sessionStorage.setItem('redirectState', state);
      }
      if (this.appConfig.useAuth0) {
        this.angularAuth0.authorize({
          redirectUri: this.appConfig.oauthCallbackUrl
        });
      } else {
        var redirectUri = location.protocol + '//' + location.host + '/login';
        var msSigninUri = 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=' + this.appConfig.msClientId + '&scope=openid profile offline_access User.Read email&response_type=code&redirect_uri=' + redirectUri;
        window.location = msSigninUri;
      }
    }
  }, {
    key: 'externalLogin2',
    value: function externalLogin2() {
      var redirectUri = location.protocol + '//' + location.host + '/login';
      var auth0SigninUri = 'https://' + this.appConfig.auth0.domain + '/authorize?response_type=token&client_id=' + this.appConfig.auth0.clientId + '&connection=&redirect_uri=' + this.appConfig.oauthCallbackUrl + '&scope=openid profile email';
      window.location = auth0SigninUri;
    }
  }, {
    key: 'handleAuth0Authentication',
    value: function handleAuth0Authentication() {
      var _this = this;

      console.log('handleAuth0Authentication');
      var loginCtrl = this;

      this.angularAuth0.parseHash(function (err, authResult) {
        console.log('parseHash', authResult);
        if (authResult && authResult.accessToken && authResult.idToken) {
          _this.authorize(authResult.idTokenPayload.email);
        } else {
          alert('There was an error logging in. Following are the error details.\nError Code: ' + err.error + '\nError Description: ' + err.errorDescription + '\n\n The system will now make an attempt to resolve the issue, after which you can try to login again');
          _this.authService.logOut();
        }
      });
    }
  }, {
    key: 'handleAuth0AuthenticationServer',
    value: function handleAuth0AuthenticationServer() {
      var _this2 = this;

      console.log('handleAuth0Authentication');
      var loginCtrl = this;

      this.angularAuth0.parseHash(function (err, authResult) {
        console.log('parseHash', authResult);
        if (authResult && authResult.accessToken && authResult.idToken) {
          _this2.authorize(authResult.idTokenPayload.email);
        } else {
          alert('There was an error logging in. Following are the error details.\nError Code: ' + err.error + '\nError Description: ' + err.errorDescription + '\n\n The system will now make an attempt to resolve the issue, after which you can try to login again');
          _this2.authService.logOut();
        }
      });
    }
  }, {
    key: 'authorize',
    value: function authorize(codeOrEmail) {
      var _this3 = this;

      var loginCtrl = this;

      this.authService.authorize(codeOrEmail).then(function (response) {
        _this3.pushService.init();
        var loc = _this3.$location;
        var redirectState = _this3.getRedirectState();

        if (redirectState) {
          var state = JSON.parse(redirectState);

          if (state.entityId) {
            _this3.authService.updateLocationLogin(state.entityId);
          }

          loginCtrl.$state.go(state.name, state.params);
        } else {
          _this3.redirectToLandingPage();
        }
      }).catch(function (err) {
        _this3.status = "";
        loginCtrl.$location.url('/login');

        var errors = [];
        for (var key in err.modelState) {
          for (var i = 0; i < err.modelState[key].length; i++) {
            errors.push(err.modelState[key][i]);
          }
        }
        loginCtrl.errorMessage = errors.join(' ');
      });
    }
  }, {
    key: 'authorize_Auth0',
    value: function authorize_Auth0(accessToken) {
      var _this4 = this;

      var loginCtrl = this;

      this.authService.authorize_Auth0(accessToken).then(function (response) {
        _this4.pushService.init();
        var loc = _this4.$location;
        var redirectState = _this4.getRedirectState();

        if (redirectState) {
          var state = JSON.parse(redirectState);

          if (state.entityId) {
            _this4.authService.updateLocationLogin(state.entityId);
          }

          loginCtrl.$state.go(state.name, state.params);
        } else {
          _this4.redirectToLandingPage();
        }
      }).catch(function (err) {
        _this4.status = "";
        loginCtrl.$location.url('/login');

        var errors = [];
        for (var key in err.modelState) {
          for (var i = 0; i < err.modelState[key].length; i++) {
            errors.push(err.modelState[key][i]);
          }
        }
        loginCtrl.errorMessage = errors.join(' ');
      });
    }
  }, {
    key: 'redirectIfAlreadyLoggedIn',
    value: function redirectIfAlreadyLoggedIn() {
      var loginCtrl = this;

      if (loginCtrl.authService.isLoggedIn()) {
        if (loginCtrl.authService.authData.isAdmin) {
          loginCtrl.$state.go('admin.listEntities');
        } else {
          loginCtrl.$state.go('user');
        }
      }

      return false;
    }
  }, {
    key: 'redirectIfAlreadyLoggedIn2',
    value: function redirectIfAlreadyLoggedIn2() {
      var loginCtrl = this;

      if (loginCtrl.authService.isLoggedIn_NoRedirect()) {
        if (loginCtrl.authService.authData.isAdmin) {
          loginCtrl.$state.go('admin.listEntities');
        } else {
          this.redirectToLandingPage();
        }
      }

      return false;
    }
  }, {
    key: 'login',
    value: function login() {
      var _this5 = this;

      var loginCtrl = this;

      this.status = 'AdminAuthorizing';

      loginCtrl.authService.login(loginCtrl.loginData).then(function (response) {
        loginCtrl.redirectIfAlreadyLoggedIn();
      }, function (err) {
        _this5.status = '';

        if (err.status === 404) {
          loginCtrl.errorMessage = 'Invalid Login Details Suppplied';
        } else {
          loginCtrl.errorMessage = err.data.message;
        }
      });
    }
  }, {
    key: 'showAdminLogin',
    value: function showAdminLogin() {
      this.hideAdminLogin();
      this.loginType = "Admin";
    }
  }, {
    key: 'hideAdminLogin',
    value: function hideAdminLogin() {
      this.loginData = {
        email: "",
        password: ""
      };

      this.loginType = '';
      this.errorMessage = '';
    }
  }, {
    key: 'getRedirectState',
    value: function getRedirectState() {
      var state = window.sessionStorage.getItem('redirectState');
      window.sessionStorage.removeItem('redirectState');
      return state;
    }
  }, {
    key: 'splitHash',
    value: function splitHash() {
      var hash = this.$location.hash();
      var params = {};
      hash.split('&').map(function (hk) {
        var temp = hk.split('=');
        params[temp[0]] = temp[1];
      });

      return params;
    }
  }, {
    key: 'redirectToLandingPage',
    value: function redirectToLandingPage() {
      switch (this.authService.authData.currentLocation.landingPage) {
        case this.enums.DEFAULT_LANDING_PAGE.WelcomeCentre:
          this.$state.go('welcomeCentre');
          break;

        case this.enums.DEFAULT_LANDING_PAGE.Dashboard:
          this.$state.go('dashboard');
          break;

        case this.enums.DEFAULT_LANDING_PAGE.LeadMonitor_WebEnquiries_Today:
          this.$state.go('leadMonitor', { dataSource: 1, dateRange: this.enums.DATE_RANGE_TYPE.Today });
          break;

        case this.enums.DEFAULT_LANDING_PAGE.LeadMonitor_WebEnquiries_ThisWeek:
          this.$state.go('leadMonitor', { dataSource: 1, dateRange: this.enums.DATE_RANGE_TYPE['This Week'] });
          break;

        case this.enums.DEFAULT_LANDING_PAGE.LeadMonitor_WebEnquiries_LastWeek:
          this.$state.go('leadMonitor', { dataSource: 1, dateRange: this.enums.DATE_RANGE_TYPE['Last Week'] });
          break;

        case this.enums.DEFAULT_LANDING_PAGE.LeadMonitor_Enquiries_Today:
          this.$state.go('leadMonitor', { dataSource: 2, dateRange: this.enums.DATE_RANGE_TYPE.Today });
          break;

        case this.enums.DEFAULT_LANDING_PAGE.LeadMonitor_Enquiries_ThisWeek:
          this.$state.go('leadMonitor', { dataSource: 2, dateRange: this.enums.DATE_RANGE_TYPE['This Week'] });
          break;

        case this.enums.DEFAULT_LANDING_PAGE.LeadMonitor_Enquiries_LastWeek:
          this.$state.go('leadMonitor', { dataSource: 2, dateRange: this.enums.DATE_RANGE_TYPE['Last Week'] });
          break;
      }
    }
  }]);
  return LoginControllerBase;
}();

exports.default = LoginControllerBase;


// WEBPACK FOOTER //
// ./client/app/components/login/LoginControllerBase.js